function getPointRouterParams(route, type, data) {
    const params = {
        path: route.path,
        query: { ...route.query }
    };

    delete params.query[type];

    if (data) {
        params.query[type] = data;
    }

    return params;
}

export const DESTINATION_NAMES = {
    current_position : 'myPosition',
    start_object: 'startObject',
    entrances: 'getEntrancesAZ',
    tenants: 'getTenantsAZ',
    services: 'getServicesObjectsAZ',
    portals: 'getPortalsForCatalogueAZ'
}

export {
    getPointRouterParams
};